import {
  INSUREDS,
  LARGE_SIZE,
  QB_CLIENTS,
  QB_RISK_COVERAGE_DEFINITION,
  QB_RISK_DEFINITION,
  REINSUREDS,
  useGetClients,
  useGetCoverageDefinition,
  useGetInsureds,
  useGetReInsureds,
  useGetRiskDefinitions,
} from 'lib/quoteBind';
import { useMemo } from 'react';

import * as utils from 'utils';

export const useFieldDefinitions = ({ productCode, isEndorsement }) => {
  const { data: riskDefinitionData, isLoading: isDefinitionLoading } = useGetRiskDefinitions(QB_RISK_DEFINITION, productCode, {
    enabled: Boolean(productCode),
    refetchOnMount: false,
  });

  const { data: clientsContent, isLoading: isClientsLoading } = useGetClients(QB_CLIENTS, { size: LARGE_SIZE, productCode });
  const { data: insuredsContent, isLoading: isInsuredsLoading } = useGetInsureds(INSUREDS, { size: 5000, productCode });
  const { data: reinsuredsContent, isLoading: isReinsuredLoading } = useGetReInsureds(REINSUREDS, { size: LARGE_SIZE, productCode });

  const { data: coverageDefinitionData } = useGetCoverageDefinition(QB_RISK_COVERAGE_DEFINITION, productCode, 'COVERAGE_COMPARISON', {
    enabled: Boolean(productCode),
  });
  const riskFieldOptions = riskDefinitionData?.data?.fieldOptions || [];

  const definitionsFields = useMemo(() => {
    const clients = clientsContent?.content || [];
    const insureds = insuredsContent?.content || [];
    const reinsureds = reinsuredsContent?.content || [];
    const riskDefinitionsFields = riskDefinitionData?.data?.product || [];

    return utils.risk.parseFields(
      riskDefinitionsFields,
      {
        insureds,
        reinsureds,
        clients,
        ...riskFieldOptions,
      },
      isEndorsement ?? false
    );
  }, [clientsContent?.content, insuredsContent?.content, reinsuredsContent?.content, riskDefinitionData?.data, isEndorsement]);

  const coverageDefinition = utils.risk.parseFields(coverageDefinitionData?.data?.product || []);
  const isLoading = isDefinitionLoading || isClientsLoading || isReinsuredLoading || isInsuredsLoading;
  return { definitionsFields, coverageDefinition, riskFieldOptions, isLoading };
};
